var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"autoFulRef",staticClass:"table-height-full flex flex-dc",style:({height: (_vm.surplusHeight + "px")})},[_c('div',{staticClass:"flex-1"},[_vm._t("table")],2),_vm._t("payTotal"),_vm._t("after")],2)}
var staticRenderFns = []

export { render, staticRenderFns }